import { LockKeyhole, ShieldCheck, UserRoundCheck } from "lucide-react";

const FEATURES = [
  {
    icon: UserRoundCheck,
    title: "无需注册",
    copy: "打开即用，不收集用户账号",
  },
  {
    icon: LockKeyhole,
    title: "不保存历史",
    copy: "仅当前页面会话可见",
  },
  {
    icon: ShieldCheck,
    title: "安全传输",
    copy: "加密上传至私有对象存储",
  },
] as const;

export function FeatureStrip() {
  return (
    <section className="feature-strip" aria-label="安全与隐私保障">
      {FEATURES.map(({ icon: Icon, title, copy }) => (
        <article className="feature-item" key={title}>
          <span className="feature-icon">
            <Icon size={26} strokeWidth={1.8} />
          </span>
          <span>
            <strong>{title}</strong>
            <small>{copy}</small>
          </span>
        </article>
      ))}
    </section>
  );
}
